module.exports = __webpack_public_path__ + "static/media/iconStudentsBoys.9853481a.svg";